// src/components/common/Spinner/Spinner.js
import React, { useState, useEffect, useMemo } from 'react';
import './Spinner.css';
import loadingGif from '../../../assets/loading.gif';

const DEFAULT_PHRASES = [
  "Conectando à base de dados do Mago...",
  "Recuperando parâmetros de gestão ESG...",
  "Analisando índices de maturidade institucional...",
  "Cruzando dados com indicadores do TCU...",
  "Processando evolução histórica dos temas...",
  "Consolidando visualizações estratégicas...",
  "Organizando prioridades e criticidade...",
  "Quase lá, finalizando o carregamento..."
];

/**
 * Spinner component with rotating phrases and a progress bar.
 * 
 * @param {string|string[]} text - A single string or an array of strings to rotate.
 * @param {boolean} fullScreen - Whether to show the spinner as a fixed overlay.
 * @param {boolean} showProgress - Whether to show the loading bar.
 */
const Spinner = ({
  text,
  fullScreen = false,
  showProgress = true
}) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const phrases = useMemo(() => {
    if (!text) return DEFAULT_PHRASES;
    if (Array.isArray(text)) return text;
    return [text];
  }, [text]);

  useEffect(() => {
    if (phrases.length <= 1) return;

    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, [phrases]);

  return (
    <div className={`spinner-container ${fullScreen ? 'full-screen' : ''}`} role="status">
      <div className="spinner-content">
        <img src={loadingGif} alt="Carregando..." className="spinner-gif" />

        <p className={`spinner-phrase ${fade ? 'spinner-fade-in' : 'spinner-fade-out'}`}>
          {phrases[currentPhraseIndex]}
        </p>

        {showProgress && (
          <div className="spinner-progress-container">
            <div className="spinner-progress-bar"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Spinner;